// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NXvt","controls":"styles_controls__3ESMw","charLimit":"styles_charLimit__24Etw","input":"styles_input__3KKZy","send":"styles_send__1OMVr"};